import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Tab, Tabs, Theme, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React, { useState } from 'react';

import { ApplicationRoutes } from '../../../../application/constants/routes';
import { TranslateText } from '../../../../application/language/TranslateText';
import ApplicationTheme from '../../../../application/theme/ApplicationTheme';
import { inject } from '../../../../common/container/inject';
import { IRouterService, RouterServiceToken } from '../../../../service/route/IRouterService';
import { Colors } from '../../../design/color/Colors';
import { IAdminPageProperties } from '../IAdminPageProperties';
import { UnitDomain } from '../unit/store/UnitDomain';
import { UnitListSearch } from '../unitListPage/parts/UnitListSearch';
import { IUnitListAdminPageDomain } from '../unitListPage/store/IUnitListAdminPageDomain';
import { UnitListAdminPageDomain } from '../unitListPage/store/UnitListAdminPageDomain';
import { UnitListAdminPage } from '../unitListPage/UnitListAdminPage';
import { UserRating } from '../usersRating/UserRating';

export const LearningAdminPage = observer(({ layoutDomain }: IAdminPageProperties) => {
  const router = inject<IRouterService>(RouterServiceToken);
  const [domain] = useState<IUnitListAdminPageDomain>(new UnitListAdminPageDomain(layoutDomain));

  const [unitDomain] = useState<UnitDomain>(new UnitDomain(layoutDomain));
  const [tabIndex, setTabIndex] = useState(0);

  const classes = useStyles();

  return (
    <ApplicationTheme>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: `1px solid ${Colors.border}`,
          marginBottom: '12px',
          paddingBottom: '12px',
          paddingTop: '8px',
          flexShrink: 0,
          overflow: 'visible',
        }}
      >
        <Typography variant="h5" sx={{ paddingLeft: '16px' }}>
          <TranslateText i18nKey="learningUserPage.learningTitle" />
        </Typography>
        <UnitListSearch domain={domain} />
      </Box>
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', typography: 'body1' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', flexShrink: 0 }}>
          <Tabs value={tabIndex} onChange={(_, v) => setTabIndex(v)} classes={{ indicator: classes.indicator }}>
            <Tab sx={{ textTransform: 'capitalize' }} label={<TranslateText i18nKey="learningUserPage.skillsMap" />} />
            <Tab
              sx={{ textTransform: 'capitalize' }}
              label={<TranslateText i18nKey="learningUserPage.usersRating" />}
            />
          </Tabs>
          <Box sx={{ display: 'flex', gap: '8px' }}>
            <Box>
              <Button
                sx={{ textTransform: 'capitalize' }}
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => {
                  unitDomain.createUnit().then((unitId) => {
                    if (typeof unitId !== 'string' || !unitId) {
                      return;
                    }
                    router.goTo(ApplicationRoutes.LearningUnitCreate.replace(':unitId', unitId));
                  });
                }}
              >
                <TranslateText i18nKey="learningAdminPage.newUnit" />
              </Button>
            </Box>
          </Box>
        </Box>
        <Box className={classes.tabPanelSkillsMap} sx={{ display: tabIndex === 0 ? 'block' : 'none' }}>
          <UnitListAdminPage domain={domain} />
        </Box>
        <Box className={classes.tabPanelUsersRating} sx={{ display: tabIndex === 1 ? 'block' : 'none' }}>
          <UserRating layoutDomain={layoutDomain} />
        </Box>
      </Box>
      </Box>
    </ApplicationTheme>
  );
});

const useStyles = makeStyles((theme: Theme) => ({
  indicator: {
    backgroundColor: Colors.primary,
  },
  tabPanelSkillsMap: {
    padding: '0px',
    flex: 1,
    minHeight: 0,
    overflowY: 'hidden',
  },
  tabPanelUsersRating: {
    padding: '0px',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    '& > div': {
      height: '100%',
      overflow: 'hidden',
    },
  },
  tabPanelRating: {
    padding: '0px',
    flex: 1,
    minHeight: 0,
    '& > div': {
      height: '100%',
    },
  },
}));
